import React from 'react'
import { Rating } from 'react-simple-star-rating'
import { FaRegStar, FaStar } from 'react-icons/fa'
import { ListRatings, Category, MarginBottom } from './styles'

const RatingByCategory = ({ category, rating, margin, color = '#EFB520' }) => {
  return (
    <ListRatings>
      <Category>{category}</Category>
      <Rating
        ratingValue={(rating * 20)}
        fillColor={color}
        allowHalfIcon
        fullIcon={<FaStar size={13} color={color} />}
        emptyIcon={ rating ? <FaRegStar size={13} color={color} /> : <FaStar size={13} color='#DADADA' />}
        readonly={true}
        spaceBetweenStar="8px"
      />
      {margin && <MarginBottom/>}
    </ListRatings>
  )
}

export default RatingByCategory
